export default {
  "empty-layout": () => import("/app/src/client/layouts/empty-layout.vue").then(m => m.default || m),
  footer: () => import("/app/src/client/layouts/footer.vue").then(m => m.default || m),
  header: () => import("/app/src/client/layouts/header.vue").then(m => m.default || m),
  homepage: () => import("/app/src/client/layouts/homepage.vue").then(m => m.default || m)
}